import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createEvent, deleteEvent, fetchEvents, fetchEventsById, updateEvent } from "../../../service/api";

export const getEvents = createAsyncThunk(
    "event/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchEvents(params)
            console.log("event ", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getEventById = createAsyncThunk(
    "event/byId",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchEventsById(params)
            console.log("event by id", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const deleteEvents = createAsyncThunk(
    "event/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteEvent(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addEvents = createAsyncThunk(
    "event/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createEvent(formValue)
            if (response.status === 201) {
                console.log("event", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editEvents = createAsyncThunk(
    "event/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateEvent(formValue)
            if (response.status === 201) {
                console.log("event", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const eventSlice = createSlice({
    name: "events",
    initialState: {
        eventList: [],
        eventById: {},
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        date: "",
        room: "",
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setDateFilter: (state, action) => {
            state.date = action.payload;
        },
        setRoomFilter: (state, action) => {
            state.room = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            //event plan
            .addCase(getEvents.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getEvents.fulfilled, (state, action) => {
                state.isLoading = false;
                state.eventList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })

            .addCase(getEvents.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //event by id
            .addCase(getEventById.pending, (state) => {
                // state.isLoading = true,
                state.error = null
            })

            .addCase(getEventById.fulfilled, (state, action) => {
                // state.isLoading = false;
                state.eventById = action.payload.data;
            })

            .addCase(getEventById.rejected, (state, action) => {
                // state.isLoading = false;
                state.error = action.payload
            })

            // POST
            .addCase(addEvents.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addEvents.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addEvents.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // delete
            .addCase(deleteEvents.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteEvents.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteEvents.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editEvents.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editEvents.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editEvents.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})
export const { setSearchParams, setPagination, setDateFilter, setRoomFilter } = eventSlice.actions;

export default eventSlice.reducer;
